<!-- Da ripulire di cose inutili -->

<template>
  <div class="nuovo_ordine" style="height: 600px">
    <v-overlay :value="caricamento" z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-toolbar dense dark color="indigo" primary-title>
      <v-toolbar-title class="white--text">
        {{
          dettaglio.num_ordine != null
            ? "Ordine N. " + dettaglio.num_ordine
            : "Nuovo Ordine"
        }}</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small light v-bind="attrs" v-on="on" @click="setDocumento()">
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
        </template>
        <span>Salva Documento</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small v-on="on" v-bind="attrs" light @click="$emit('goBack')">
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-card style="height: 100vh">
      <v-container style="background-color: white">
        <v-form ref="bolla_form">
          <v-row class="mx-0" justify="center" align="center">
            <v-spacer></v-spacer>
            <v-col cols="3">
              <v-text-field
                class="mr-2"
                label="Fornitore"
                v-model="dettaglio.ragione_sociale"
                required
                :rules="regole.no_null_str"
              >
              </v-text-field>
            </v-col>
            <v-col cols="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-2"
                    small
                    v-on="on"
                    v-bind="attrs"
                    @click="goToAnagrafica"
                    ><v-icon color="success">mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Vai al fornitore</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-on="on"
                    v-bind="attrs"
                    @click="getAnagrafica"
                    @keyup.enter.native="getAnagrafica"
                    ><v-icon color="primary">mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Cerca fornitore</span>
              </v-tooltip>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="3">
              <v-text-field
                label="Numero Ordine"
                prepend-icon="mdi-file-document-multiple"
                v-model="dettaglio.num_ordine"
                required
                :rules="regole.no_null_str"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="4">
              <InputCalendario
                label="Data"
                v-model="dettaglio.data_documento"
                required
                :rules="regole.no_null_str"
              />
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-form>

        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="tabella.testata"
              :items="tabella.dati.filter((e) => e.validita == 1)"
            >
              <!-- Colonna del modifica -->
              <template v-slot:[`item.modifica`]="{ item }">
                <v-btn
                  @click="
                    dialog_buffer = item;
                    dialog_inserimento.mostra = true;
                    console(item);
                  "
                  small
                  ><v-icon color="primary">mdi-pencil</v-icon></v-btn
                >
              </template>
              <!-- Colonna del delete -->
              <template v-slot:[`item.delete`]="{ item }">
                <v-btn
                  v-if="item.qnt_ricevuta == null"
                  @click="eliminaArticolo(item)"
                  small
                  ><v-icon color="error">mdi-delete</v-icon></v-btn
                >
              </template>
              <!-- Colonna della quantità residua -->
              <template v-slot:[`item.quantita_residua`]="{ item }">
                {{ item.quantita_residua }}
                <v-btn
                  @click="
                    vediDDT(item);
                    dialogDDT = true;
                  "
                  icon
                  small
                  ><v-icon color="primary"> mdi-file-rotate-right </v-icon>
                </v-btn>
              </template>
              <template v-slot:top>
                <v-toolbar color="indigo" dense>
                  <v-toolbar-title class="white--text">
                    Articoli
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        small
                        @click="dialog_inserimento.mostra = true"
                      >
                        <v-icon color="primary">mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Aggiungi Articolo</span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>

      <!-- DIALOG AGG ART -->
      <v-dialog persistent v-model="dialog_inserimento.mostra" width="900px">
        <v-card>
          <v-toolbar color="indigo" dense dark>
            <v-toolbar-title>{{
              dialog_buffer.id_documento_dettaglio == null ||
              dialog_buffer.id_documento_dettaglio == -1
                ? "Aggiungi Articolo"
                : "Modifica Articolo"
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  @click="salvaModifiche"
                  light
                  small
                >
                  <v-icon color="success">mdi-floppy</v-icon>
                </v-btn>
              </template>
              <span>Salva Articolo</span>
            </v-tooltip>

            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  @click="
                    dialog_inserimento.mostra = false;
                    resetDialog_buffer();
                  "
                  light
                  small
                >
                  <v-icon color="error">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Indietro</span>
            </v-tooltip>
          </v-toolbar>

          <v-container>
            <v-form ref="form">
              <v-row align="center" justify="center">
                <v-col class="py-0">
                  <v-row align="center" justify="center">
                    <v-col class="py-0">
                      <v-row align="center" justify="center">
                        <v-text-field
                          class="ml-3 mt-5"
                          label="Cod. Articolo"
                          dense
                          required
                          :rules="regole.no_null_str"
                          v-model="dialog_buffer.cod_articolo"
                        ></v-text-field>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="mr-2 ml-3"
                              v-on="on"
                              v-bind="attrs"
                              @click="goToArticolo"
                              small
                            >
                              <v-icon color="success">mdi-check</v-icon>
                            </v-btn>
                          </template>
                          <span>Vai all'Articolo</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="mr-2"
                              v-on="on"
                              v-bind="attrs"
                              @click="getArticoli"
                              small
                            >
                              <v-icon color="primary">mdi-magnify</v-icon>
                            </v-btn>
                          </template>
                          <span>Cerca</span>
                        </v-tooltip>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="py-0" cols="4">
                  <v-text-field
                    label="Descrizione"
                    readonly
                    v-model="dialog_buffer.descrizione"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col class="py-0">
                  <v-text-field
                    type="number"
                    @change="sistemaQuantita()"
                    :min="
                      dialog_buffer.qnt_ricevuta == null
                        ? 0
                        : dialog_buffer.qnt_ricevuta
                    "
                    label="Quantità Totale"
                    v-model.number="dialog_buffer.quantita"
                    required
                    :rules="regole.no_null_num"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    label="Unità di Misura"
                    readonly
                    v-model="dialog_buffer.um"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    type="date"
                    label="Data consegna"
                    v-model="dialog_buffer.data_consegna"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    label="Riga Ordine (auto)"
                    readonly
                    v-model="dialog_buffer.riga_ordine"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <v-overlay :value="caricamento" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-dialog>

      <!-- DIALOG ricerca cod articolo -->
      <v-dialog v-model="dialog_lista.mostra" width="700" persistent>
        <v-card>
          <v-toolbar color="indigo" dense dark>
            <v-toolbar-title>Seleziona Articolo</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="chiudiDialogRicercaArt" light small>
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="dialog_lista.tabella.testata"
                  :items="dialog_lista.tabella.dati"
                >
                  <template v-slot:item="{ item }">
                    <tr
                      class="record_tabella"
                      :data-deleted="item.validita == 0 ? true : false"
                    >
                      <td>
                        <v-btn small @click="selezionaArticolo(item)">
                          <v-icon color="primary">mdi-check</v-icon>
                        </v-btn>
                      </td>
                      <td
                        v-for="(colonna, i) in dialog_lista.tabella.testata"
                        :key="i"
                        v-show="colonna.value != null"
                      >
                        {{ item[colonna.value] }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- DIALOG RICERCA FORNITORE -->
      <v-dialog v-model="dialogSearchAnagrafica" width="700" persistent>
        <v-card>
          <v-toolbar color="indigo" dense dark>
            <v-toolbar-title>Seleziona Fornitore</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="chiudiDialogRicercaFornitore" light small>
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="ragioneSociale"
                  :items="ragioneSocialeLista"
                >
                  <template v-slot:item="{ item }">
                    <tr
                      class="record_tabella"
                      :data-deleted="item.validita == 0 ? true : false"
                    >
                      <td>
                        <v-btn small @click="selezionaAnagrafica(item)"
                          ><v-icon color="primary">mdi-check</v-icon></v-btn
                        >
                      </td>
                      <td
                        v-for="(colonna, i) in ragioneSociale"
                        :key="i"
                        v-show="colonna.value != null"
                      >
                        {{ item[colonna.value] }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col></v-row
            >
          </v-container>
        </v-card>
      </v-dialog>

      <!-- DIALOG DDT -->
      <v-dialog v-model="dialogDDT" width="900" persistent>
        <v-card>
          <v-toolbar color="indigo" dense dark>
            <v-toolbar-title
              >DDT relativi all'articolo selezionato</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn @click="dialogDDT = false" light small>
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table :headers="header_DDT" :items="lista_DDT">
                </v-data-table> </v-col
            ></v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- SNACKBAR -->
      <v-snackbar
        content-class="snackbar"
        :color="snackbar_background"
        right
        v-model="snackbar"
        :timeout="3000"
      >
        <v-icon :color="snackbar_icon_color" :size="64">{{
          snackbar_icon
        }}</v-icon>
        <h2
          :style="{ color: snackbar_text_color + '!important' }"
          class="ml-16"
        >
          {{ snackbar_text }}
        </h2>

        <v-btn
          @click="snackbar = false"
          fab
          dark
          text
          small
          style="
            margin-top: -6rem;
            float: right !important;
            margin-right: -1rem !important;
          "
        >
          <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-card>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import InputCalendario from "@/components/PRODUCTION/Magazzino/InputCalendario.vue";
import moment from "moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "NuovoOrdine",
  components: {
    InputCalendario,
    SnackbarQV,
  },
  props: {
    selez: { type: Number, default: null },
    nuovo: { type: Boolean, default: true },
  },
  data() {
    return {
      from_ordine: false,
      articoli_search: "",
      qtaDisp: null,
      itemTmp: null,
      lista_um: [],
      array_ordini_quantita: [],
      array_tmp_ord_qnt: [],
      ordine_tmp: null,
      codice_fornitore: null,
      dialog_lista_ordini: false,
      caricamento: false,
      qr_code_sel: "",
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_icon_color: "",
      snackbar_text: "",
      snackbar_text_color: "",
      dialogDDT: false,
      lista_DDT: [],
      header_DDT: [
        { text: "Numero", value: "num_documento" },
        { text: "Data", value: "data_documento" },
        { text: "Codice Articolo", value: "cod_articolo", align: "start" },
        { text: "Descrizione", value: "descrizione" },
        { text: "Quantità", value: "quantita" },
        { text: "Numero lotto", value: "cod_lotto" },
        { text: "Lotto fornitore", value: "lotto_fornitore" },
      ],
      ricerca_anagrafica: null,
      ragioneSocialeLista: [],
      ragioneSociale: [
        { text: null, value: null, align: "start" },
        { text: "Ragione Sociale", value: "ragione_sociale" },
        { text: "Cod. Fornitore", value: "codice" },
        { text: "Indrizzo", value: "indirizzo" },
      ],
      ordini_originali: [],
      dialogSearchAnagrafica: false,

      // Da modificare con i dati dell'ordine
      dettaglio: {
        id_documento: -1,
        cod_documento: "ORDF",
        num_ordine: null,
        data_documento: moment().format("YYYY-MM-DD"),
        data_consegna: null,
        id_anagrafica: null,
        tipo_soggetto: null,
        validita: 1,
        ragione_sociale: null,
        dettaglio: [],
      },

      tabellaOrdini: {
        testata: [
          { text: null, value: null },
          { text: "Numero Ordine", value: "NUM_ORDINE", align: "start" },
          { text: "Cod. Articolo", value: "COD_ARTICOLO" },
          { text: "Des. Articolo", value: "descrizione" },
          { text: "Num. Seriale", value: "NUM_SERIALE" },
          { text: "Data Consegna", value: "DATA_CONSEGNA" },
          { text: "Quantità", value: "QUANTITA" },
        ],
        dati: [],
      },
      items_articoli: [],
      tabella: {
        testata: [
          { text: "Modifica", value: "modifica" },
          { text: "Codice Articolo", value: "cod_articolo", align: "start" },
          { text: "Descrizione", value: "descrizione" },
          { text: "Quantità", value: "quantita" },
          { text: "Quantità residua", value: "quantita_residua" },
          { text: "Data consegna", value: "data_consegna" },
          { text: "Unità di Misura", value: "um" },
          { text: "Riga Ordine", value: "num_riga" },
          { text: "Elimina", value: "delete" },
        ],
        dati: [],
      },
      dialog_inserimento: {
        indice: -1,
        mostra: false,
      },
      dialog_buffer: {
        id_documento_dettaglio: -1,
        id_documento: -1,
        id_articolo: null,
        descrizione: null,
        cod_articolo: null,
        data_consegna: null,
        peso_unitario: null,
        id_um: null,
        um: null,
        quantita: null,
        num_colli: 1,
        cod_timbro: null,
        lotto_fornitore: null,
        cod_lotto: null,
        num_riga: null,
        stato_riga: null,
        num_ordine: null,
        riga_ordine: null,
        qta_per_collo: true,
        validita: 1,
      },
      dialog_lista: {
        caricamento: false,
        mostra: false,
        ricerca: null,
        tabella: {
          testata: [
            { text: null, value: null, align: "start" },
            { text: "Codice Articolo", value: "cod_articolo" },
            { text: "Descrizione Articolo", value: "des_articolo" },
          ],
          dati: [],
        },
      },
      regole: {
        no_null_str: [
          (valore) =>
            (valore != null && valore != undefined
              ? valore.toString().length > 0
              : false) || "Campo obbligatorio",
        ],
        no_null_num: [
          (valore) =>
            (valore != null &&
              valore != undefined &&
              !isNaN(valore) &&
              valore > 0) ||
            "Campo obbligatorio",
        ],
      },
    };
  },
  watch: {},
  mounted() {
    if (!this.nuovo) {
      this.getDocumento();
    }
  },

  methods: {
    eliminaFiltro() {
      this.articoli_search = "";
      this.items_articoli = Array.from(this.tabellaOrdini.dati);
    },
    filtra() {
      let items_articoli_tmp = [];
      this.items_articoli.forEach((elem) => {
        items_articoli_tmp.push(elem);
      });

      if (this.articoli_search != "") {
        // Faccio un array temporaneo
        let res = [];

        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_articoli_tmp.forEach((elem) => {
          if (elem.COD_ARTICOLO == this.articoli_search) {
            res.push(elem);
          }
        });

        items_articoli_tmp = res;
      }

      this.items_articoli = [];
      this.items_articoli = items_articoli_tmp;
    },
    popolaRiepilogo() {
      const array_tmp = new Array();

      this.tabella.dati.forEach((e) => {
        let ricorre = false;

        array_tmp.forEach((f) => {
          if (e.cod_articolo === f.cod_articolo) {
            ricorre = true;
          }
        });

        if (ricorre === false) {
          let colli = 0;
          let quantita = 0;

          this.tabella.dati.forEach((f) => {
            if (e.cod_articolo === f.cod_articolo && f.validita != 0) {
              colli += f.num_colli;
              quantita = parseInt(quantita) + parseInt(f.quantita);
            }
          });

          array_tmp.push({
            cod_articolo: e.cod_articolo,
            colli: colli,
            quantita: quantita,
          });
        }
      });

      return array_tmp;
    },

    backFromListaOrdini() {
      // this.tabellaOrdini.dati = [];
      this.dialog_lista_ordini = false;
    },

    chiudiDialogRicercaArt() {
      this.dialog_lista.mostra = false;
      this.dialog_lista.ricerca = null;
    },
    chiudiDialogRicercaFornitore() {
      this.dialogSearchAnagrafica = false;
      this.ricerca_anagrafica = null;
    },

    /* DIALOG */
    mostraDialog(riga, clona = false) {
      console.log("click agg", this.dialog_buffer);
      let indice = this.tabella.dati.indexOf(riga);
      this.dialog_inserimento.indice = indice;
      let campi = Object.keys(this.dialog_buffer);
      for (let i = 0; i < campi.length; i++) {
        if (campi[i] === "num_colli") {
          this.dialog_buffer["num_colli"] = 1;
        } else {
          this.dialog_buffer[campi[i]] = indice >= 0 ? riga[campi[i]] : null;
        }
      }

      this.dialog_inserimento.mostra = true;
      if (clona) {
        this.dialog_inserimento.indice = -1;
      }
      let that = this;
      this.$nextTick(function () {
        that.$refs.form.resetValidation();
      });

      console.log("dialog buffer", this.dialog_buffer);
    },
    ripristinaRiga(riga) {
      // this.dialog_inserimento.indice = riga.riga_ordine - 1;
      riga.validita = 1;

      console.log(
        "ripristina riga, dialog_inserimento.indice modifica da eseguire: ",
        this.dialog_inserimento.indice
      );
    },

    resetDialog_buffer() {
      this.dialog_buffer = {
        id_documento_dettaglio: -1,
        id_documento: -1,
        id_articolo: null,
        descrizione: null,
        cod_articolo: null,
        data_consegna: null,
        peso_unitario: null,
        id_um: null,
        um: null,
        quantita: null,
        num_colli: 1,
        cod_timbro: null,
        lotto_fornitore: null,
        cod_lotto: null,
        num_riga: null,
        stato_riga: null,
        num_ordine: null,
        riga_ordine: null,
        qta_per_collo: true,
        validita: 1,
      };
    },

    selezionaArticolo(articolo) {
      this.from_ordine = false;
      this.dialog_buffer.cod_articolo = articolo.cod_articolo;
      this.dialog_buffer.id_articolo = articolo.id_articolo;
      this.dialog_buffer.um = articolo.des_um;
      this.dialog_buffer.id_um = articolo.id_um;
      this.dialog_buffer.descrizione = articolo.des_articolo;
      this.dialog_lista.mostra = false;
    },
    selezionaAnagrafica(fornitore) {
      this.dettaglio.tipo_soggetto = fornitore.tipo;
      this.dettaglio.id_anagrafica = fornitore.id_anagrafica;
      this.dettaglio.ragione_sociale = fornitore.ragione_sociale;
      this.codice_fornitore = fornitore.codice;
      this.dialogSearchAnagrafica = false;
    },

    async salvaModifiche() {
      let magazzini = await this.checkMagazzini(this.dialog_buffer.id_articolo);
      console.log("Magazzini:", magazzini);

      if (magazzini) {
        if (
          this.dialog_buffer.id_documento_dettaglio != null &&
          this.dialog_buffer.id_documento_dettaglio != -1
        ) {
          console.log("articolo in modifica");
          this.tabella.dati.forEach((e) => {
            if (
              e.id_documento_dettaglio ==
              this.dialog_buffer.id_documento_dettaglio
            ) {
              console.log(e);
              e.quantita = this.dialog_buffer.quantita;
              e.cod_articolo = this.dialog_buffer.cod_articolo;
              e.cod_lotto = this.dialog_buffer.cod_lotto;
              e.descrizione = this.dialog_buffer.descrizione;
              e.lotto_fornitore = this.dialog_buffer.lotto_fornitore;
              e.num_colli = this.dialog_buffer.num_colli;
              e.peso_unitario = this.dialog_buffer.peso_unitario;
              e.qta_per_collo = this.dialog_buffer.qta_per_collo;
              e.qnt_ricevuta = this.dialog_buffer.qnt_ricevuta;
              e.um = this.dialog_buffer.um;
            }
          });
          this.resetDialog_buffer();
          this.dialog_inserimento.mostra = false;
          return;
        }
        console.log("entrato 2");

        // Poi mi costruisco l'oggetto per il salvataggio
        let clone = Object.assign({}, this.dialog_buffer);
        clone.residuo = clone.quantita;
        clone.validita = 1;
        clone.id_documento_dettaglio = -1;
        clone.id_documento = -1;
        clone.qnt_ricevuta = null;

        /* Mi faccio un array di supporto da usare
         * nel resto della logica di salvataggio. */
        const arr_tmp = this.tabellaOrdini.dati.filter(
          (elem) => elem.COD_ARTICOLO === clone.cod_articolo
        );

        /* Controllo che tutti gli oggetti messi in arr_tmp abbiano una data
         * valida, altrimenti la funzione da risultati erratici. */
        let check_data = true;
        arr_tmp.forEach((elem) => {
          if (!elem.DATA_CONSEGNA.includes("-")) {
            check_data = false;
          }
        });

        if (check_data === true) {
          this.$refs.SnackbarQV.print(
            "orange",
            "I dati degli ordini non sono corretti, impossibile leggere i dati."
          );
        }

        /* // Controllo che le quantità in ordine non eccedano oltre i 500
      // let somma = 0;
      // arr_tmp.forEach((elem) => {
      //   if (elem.COD_ARTICOLO === clone.cod_articolo) {
      //     somma += elem.QUANTITA;
      //   }
      // });

      // if (clone.residuo - somma <= 500) {
      /* Se il controllo della quantità è pasato, procedo
       * a praprare gli oggetti per il salvataggio. */
        let qta_div_colli = clone.residuo;
        if (clone.num_colli > 1) {
          qta_div_colli = parseInt(clone.residuo / clone.num_colli);
        }

        let qta_rimasta = clone.residuo;
        for (let i = 0; i < clone.num_colli; i++) {
          // Questo se è quantità totale (da dividere per numero di colli)...
          if (this.dialog_buffer.qta_per_collo === true) {
            qta_rimasta = this.dialog_buffer.quantita;
          } else {
            if (i < clone.num_colli - 1) {
              qta_rimasta = qta_div_colli;
            } else {
              qta_rimasta = this.dialog_buffer.quantita - qta_div_colli * i;
            }
          }

          // ... Altrimenti...

          let int_riga = 0;

          clone.quantita = qta_rimasta;
          while (qta_rimasta > 0 && int_riga < arr_tmp.length) {
            if (qta_rimasta <= arr_tmp[int_riga].QUANTITA) {
              arr_tmp[int_riga].QUANTITA -= qta_rimasta;
              qta_rimasta = 0;
            } else {
              qta_rimasta -= arr_tmp[int_riga].QUANTITA;
              arr_tmp[int_riga].QUANTITA = 0;
            }

            if (
              moment(`${arr_tmp[int_riga].DATA_CONSEGNA.split(" ")[0]}`) >
              moment()
            ) {
              this.$refs.SnackbarQV.print(
                "success",
                `Quantità in acconto sulla prossima consegna del ${
                  arr_tmp[int_riga].DATA_CONSEGNA.split("-")[2]
                }/${arr_tmp[int_riga].DATA_CONSEGNA.split("-")[1]}/${
                  arr_tmp[int_riga].DATA_CONSEGNA.split("-")[0]
                }.`
              );
            }

            int_riga++;
          }
          if (qta_rimasta > 0 && arr_tmp.length > 0) {
            arr_tmp[arr_tmp.length - 1].QUANTITA -= qta_rimasta;
          }

          clone.residuo = qta_rimasta;

          let clone2 = Object.assign({}, clone);
          clone2.num_colli = 1;

          // Se è un oggetto nuovo, lo inserisco in coda alla tabella
          if (this.dialog_inserimento.indice < 0) {
            this.tabella.dati.push(Object.assign({}, clone2));
            console.log("entrato new");
          } else {
            console.log("entrato old");
            // Se non è un oggetto nuovo, modifico la riga di tabella corrispondente
            this.tabella.dati[this.dialog_inserimento.indice] = Object.assign(
              {},
              clone2
            );
          }

          if (this.qr_attivo) {
            this.$refs.SnackbarQV.print("success", "QR valido.");
            this.$refs.qr.attiva_telecamera();
          } else {
            this.$refs.SnackbarQV.print("success", "Ingresso registrato.");
          }

          /* Aggiorno le tabelle degli ordini in items_articoli
           * e in tabellaOrdini.dati in modo che i dati visualizzati
           * siano aggiornati. */
          for (let j = 0; j < arr_tmp.length; j++) {
            for (let k = 0; k < this.items_articoli.length; k++) {
              if (
                this.items_articoli[k].NUM_ORDINE === arr_tmp[j].NUM_ORDINE &&
                this.items_articoli[k].RIGA_ORDINE === arr_tmp[j].RIGA_ORDINE &&
                this.items_articoli[k].DATA_CONSEGNA ===
                  arr_tmp[j].DATA_CONSEGNA &&
                this.items_articoli[k].COD_ARTICOLO === arr_tmp[j].COD_ARTICOLO
              ) {
                this.items_articoli[k].QUANTITA = arr_tmp[j].QUANTITA;
              }
            }
          }
        }

        for (let i = 0; i < this.tabella.dati.length; i++) {
          if (this.tabella.dati[i].validita == 1) {
            this.tabella.dati[i].num_riga = i + 1;
          }
        }
        this.dialog_inserimento.mostra = false;
        this.resetDialog_buffer();
      } else {
        this.$refs.SnackbarQV.print(
          "error",
          "Nessun magazzino predefinito, impossibile aggiungere l'articolo."
        );
      }
    },

    console(item) {
      console.log(item);
    },

    clickStampaAccettazioni() {
      this.conferma_stampa_visible = true;
    },
    stampaAccettazioni() {
      console.log(
        `Stampa ${
          this.tabella.dati.filter((e) => e.stampa === true).length
        } articoli.`
      );
      this.conferma_stampa_visible = false;
    },

    // Questa chiamata permetteva di avere i dati di un articolo selezionato manualmente
    // dalla lista degli articoli, per scelte implementative si è deciso di prendere
    // i dettagli dell'articolo dalla selezione nella lista degli ordini.
    getArticoli() {
      this.dialog_lista.caricamento = true;

      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getArticoli",
          token: localStorage.user_token,
          cod_articolo: this.dialog_buffer.cod_articolo,
        },
      };
      let that = this;
      this.$store.dispatch("api", richiesta).then((risposta) => {
        if (risposta.data.lista.length > 1) {
          that.dialog_lista.tabella.dati = risposta.data.lista;
          // that.dialog_lista.caricamento = false;
          this.dialog_lista.mostra = true;
        }

        if (risposta.data.lista.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text =
            "Non sono stati trovati articoli con questo nome.";
          this.snackbar_text_color = "white";
        }

        if (risposta.data.lista.length === 1) {
          that.dialog_lista.tabella.dati = risposta.data.lista;
          that.dialog_lista.caricamento = false;
          this.dialog_lista.mostra = true;
        }
      });
    },

    getAnagrafica() {
      let searchReq = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getragionesociale",
          token: localStorage.getItem("user_token"),
          // cod_anagrafica: this.cod_anagrafica,
          des_anagrafica: this.dettaglio.ragione_sociale,
          tipo_anagrafica: "F",
        },
      };
      this.$store.dispatch("api", searchReq).then((res) => {
        if (res.data.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Il Fornitore non è stato trovato. Riprova!";
          this.snackbar_text_color = "white";
          this.loadingVal = false;
          this.progressBar = false;
          this.savebutton = false;
          this.topDiv = true;
        }
        if (res.data.length > 1) {
          this.ragioneSocialeLista = res.data;
          this.dialogSearchAnagrafica = true;
        }
        if (res.data.length == 1) {
          this.dialogSearchAnagrafica = true;
          this.overlay = false;
          this.ragioneSocialeLista = res.data;
          this.dialogSearchAnagrafica = true;
        }
      });
    },

    getDocumento() {
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdocumento",
          token: localStorage.user_token,
          id_documento: this.selez,
        },
      };
      this.$store.dispatch("api", richiesta).then((risposta) => {
        this.dettaglio = Object.assign({}, risposta.data.documento[0]);
        this.dettaglio.num_ordine = this.dettaglio.num_documento;
        console.log(this.dettaglio.num_ordine);

        if (!this.admin_power && risposta.data.documento[0].dettaglio != null) {
          let res = risposta.data.documento[0].dettaglio;
          const arr = res.filter((elem) => elem.validita);
          this.tabella.dati = arr;
        } else if (risposta.data.documento[0].dettaglio != null) {
          this.tabella.dati = risposta.data.documento[0].dettaglio;
        }
        this.codice_fornitore = this.dettaglio.cod_anagrafica;
        this.tabella.dati.forEach((e) => {
          e.quantita_residua = e.quantita - e.qnt_ricevuta;
        });
      });
    },

    goToAnagrafica() {
      if (
        this.dettaglio.ragione_sociale === "" ||
        this.dettaglio.ragione_sociale === null
      ) {
        return;
      }

      // this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getragionesociale",

          token: localStorage.getItem("user_token"),
          des_anagrafica: this.dettaglio.ragione_sociale,
          id_famiglia:
            this.id_famiglia_sel == null ? "" : this.id_famiglia.id_tabella,
          id_tipo: this.id_tipo == null ? "" : this.id_tipo.id_tabella,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;

        if (res.data.length > 1) {
          this.snackbar = true;
          this.snackbar_background = "orange";
          this.snackbar_icon = "mdi-alert";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Sono presenti più fornitori con questo nome.";
          this.snackbar_text_color = "white";
          this.ragioneSocialeLista = res.data;
          this.dialogSearchAnagrafica = true;
        }

        if (res.data.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text =
            "Non sono stati trovati fornitori con questo nome.";
          this.snackbar_text_color = "white";
        }

        if (res.data.length === 1) {
          this.selezionaAnagrafica(res.data[0]);
        }
      });

      // this.articolo_search_results = false;
    },

    eliminaArticolo(item) {
      console.log(item);
      item.validita = 0;
      let index = 0;
      for (let i = 0; i < this.tabella.dati.length; i++) {
        if (this.tabella.dati[i].validita == 1) {
          this.tabella.dati[i].num_riga = index + 1;
          index++;
        }
      }
    },

    // Commentata questa sezione perché l'inserimento dell'articolo
    // deve essere inserito dal dialog di selezione dell'ordine.
    goToArticolo() {
      if (this.dialog_buffer.cod_articolo === "") {
        return;
      }

      // this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.dialog_buffer.cod_articolo,
          id_famiglia:
            this.id_famiglia_sel == null ? "" : this.id_famiglia.id_tabella,
          id_tipo: this.id_tipo == null ? "" : this.id_tipo.id_tabella,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;

        if (res.data.lista.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text =
            "Non sono stati trovati articoli con questo codice.";
          this.snackbar_text_color = "white";
        }

        if (res.data.lista.length === 1) {
          this.selezionaArticolo(res.data.lista[0]);
        }
      });

      // this.articolo_search_results = false;
    },

    checkMagazzini(id_articolo) {
      let mag_pred = false;
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticolomagazzini",
          id_articolo: id_articolo,
          token: localStorage.user_token,
        },
      };
      return this.$store.dispatch("api", richiesta).then((risposta) => {
        if (risposta.data != null) {
          risposta.data.forEach((e) => {
            if (e.magazzino_predefinito == 1) {
              mag_pred = true;
            }
          });
          return mag_pred;
        } else {
          return 0;
        }
      });
    },

    setDocumento() {
      console.log("Dettaglio", this.dettaglio);
      this.dettaglio.num_documento = this.dettaglio.num_ordine;
      console.log("Dati articolo", this.tabella.dati);
      this.tabella.dati.forEach((e) => {
        e.num_documento = this.dettaglio.num_documento;
      });

      // Controllo che ci sia almeno una riga d'ordine all'interno del DDT
      /* if (this.tabella.dati.filter((e) => e.validita === 1).length === 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Inserire almeno una riga nell'ordine.",
          10000
        );
      } */

      this.dettaglio.dettaglio = this.tabella.dati;
      console.log(this.dettaglio.dettaglio);

      this.caricamento = true;
      console.log(this.dettaglio.data_documento);
      if (this.dettaglio.data_documento.includes("/")) {
        let date_time = (this.dettaglio.data_documento =
          this.dettaglio.data_documento.split("/"));
        this.dettaglio.data_documento =
          date_time[2] + "-" + date_time[1] + "-" + date_time[0];
      }

      console.log(this.dettaglio);
      // Compongo la request
      let richiesta = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setordini",
          token: localStorage.user_token,
          documento: [this.dettaglio],
          // Lista di articoli
          documento_dettaglio: this.dettaglio.dettaglio,
        },
      };

      this.$store
        .dispatch("api", richiesta)
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            this.caricamento = false;
            this.from_ordine = false;
            this.$refs.SnackbarQV.print(
              "success",
              "Ordine registrato con successo"
            );

            this.$emit("goBack");
            delete this.dettaglio.num_ordine;
          } else {
            this.caricamento = false;
            this.from_ordine = false;
            this.$refs.SnackbarQV.print(
              "error",
              "Errore nello scambio di dati col server."
            );
          }
        })
        .catch((e) => {
      /*     if (e.statusCode == 400) {
            console.error(e, "entrato 1");
          }
          if (e.status == 400) {
            console.error(e, "entrato 2");
          } */
          console.log(`${JSON.parse(e.response.data.message).result}`);
          if (
            JSON.parse(e.response.data.message).result.includes("Errore num_documento duplicato")
          ) {
            this.caricamento = false;
             console.error(e, "entrato 2");
            this.$refs.SnackbarQV.print(
              "orange",
              "Numero ordine già presente."
            );
          }
        });
    },

    sistemaQuantita() {
      if (this.dialog_buffer.quantita < this.dialog_buffer.qnt_ricevuta) {
        this.dialog_buffer.quantita = this.dialog_buffer.qnt_ricevuta;
      }
    },

    vediDDT(item) {
      this.lista_DDT = [];
      console.log(item);
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdocumento",
          token: localStorage.user_token,
          id_documento_rif: item.id_documento,
          id_documento_dettaglio_rif: item.id_documento_dettaglio,
          id_articolo: item.id_articolo,
        },
      };
      this.$store.dispatch("api", richiesta).then((risposta) => {
        if (risposta.data.documento != null) {
          let lista_temp = risposta.data.documento;
          this.lista_DDT;
          lista_temp.forEach((doc) => {
            doc.dettaglio.forEach((art) => {
              art.data_documento = doc.data_documento;
              art.num_documento = doc.num_documento;
              this.lista_DDT.push(art);
            });
          });

          console.log(this.lista_DDT);
        }
      });
    },
  },
};
</script>

<style scoped>
.nuovo_ordine {
  position: relative;
  height: 60vh;
}
.nuovo_ordine > header {
  border-radius: inherit;
  overflow: hidden;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.record_tabella {
  text-align: left;
}
.record_tabella > td {
  text-align: left;
}
.record_tabella[data-deleted] {
  background-color: #ffcccc !important;
}
.record_tabella[data-deleted]:hover {
  background-color: #ffb3b3 !important;
}
</style>